import type { MERGE_CONFIDENCE } from './common';

export type MergeConfidence = (typeof MERGE_CONFIDENCE)[number];
